<section id="insurance-claims-page" class="w-full min-h-screen bg-ld-neutral-50">
  <div class="max-w-page mx-auto py-6 page-content-padding">
    <header id="insurance-claims-header" class="mb-6">
      <h1 id="insurance-claims-title" class="text-page-title">
        {{ 'insuranceClaimsTitle' | transloco }}
      </h1>
      <p id="insurance-claims-subtitle" class="text-base text-ld-neutral-500 mt-2">
        {{ 'insuranceClaimsSubtitle' | transloco }}
      </p>
    </header>

    <div class="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-6">
      <div id="insurance-claims-content-section" class="flex flex-col gap-4">
        <div class="card-base-sm p-6">
          <h2 id="insurance-claims-question-heading" class="text-section-heading text-ld-primary mb-3">
            {{ 'insuranceClaimsQuestionTitle' | transloco }}
          </h2>

          <p id="insurance-claims-intro" class="text-body text-ld-neutral-700 leading-relaxed mb-6">
            {{ 'insuranceClaimsIntroText' | transloco }}
          </p>

          <h3 id="insurance-claims-packet-heading" class="text-card-title text-ld-primary mb-4">
            {{ 'insuranceClaimsPacketTitle' | transloco }}
          </h3>

          <ol id="insurance-claims-steps" class="list-decimal list-outside ml-4 space-y-4 text-sm text-ld-neutral-700">
            <li id="insurance-claims-step-1">
              {{ 'insuranceClaimsStep1' | transloco }}
              <br />
              <a
                id="insurance-claims-packet-link"
                href="javascript:void(0)"
                class="inline-flex items-center gap-1 text-ld-link font-medium hover:underline cursor-pointer mt-1"
                (click)="openDocument($event, claimProcedurePacketUrl)"
              >
                <mat-icon class="size-4! text-base!">description</mat-icon>
                {{ 'contactUsClaimProcedurePacket' | transloco }}
              </a>
            </li>

            <li id="insurance-claims-step-2">
              {{ 'insuranceClaimsStep2' | transloco }}
              <ul class="list-disc list-outside ml-4 mt-2 space-y-1">
                <li>{{ 'insuranceClaimsStep2Item1' | transloco }}</li>
                <li>{{ 'insuranceClaimsStep2Item2' | transloco }}</li>
                <li>{{ 'insuranceClaimsStep2Item3' | transloco }}</li>
                <li>{{ 'insuranceClaimsStep2Item4' | transloco }}</li>
                <li>{{ 'insuranceClaimsStep2Item5' | transloco }}</li>
                <li>
                  {{ 'insuranceClaimsStep2Item6' | transloco }}
                  <ol class="list-[lower-alpha] list-outside ml-4 mt-1 space-y-1">
                    <li>{{ 'insuranceClaimsStep2Item6a' | transloco }}</li>
                    <li>{{ 'insuranceClaimsStep2Item6b' | transloco }}</li>
                    <li>{{ 'insuranceClaimsStep2Item6c' | transloco }}</li>
                    <li>{{ 'insuranceClaimsStep2Item6d' | transloco }}</li>
                  </ol>
                </li>
                <li>{{ 'insuranceClaimsStep2Item7' | transloco }}</li>
                <li>{{ 'insuranceClaimsStep2Item8' | transloco }}</li>
              </ul>
            </li>

            <li id="insurance-claims-step-3">
              {{ 'insuranceClaimsStep3' | transloco }}
              <address class="not-italic mt-2 ml-2 text-ld-neutral-700">
                <p>{{ 'insuranceClaimsAddressLine1' | transloco }}</p>
                <p>{{ 'insuranceClaimsAddressLine2' | transloco }}</p>
                <p>{{ 'insuranceClaimsAddressLine3' | transloco }}</p>
                <p>{{ 'insuranceClaimsAddressLine4' | transloco }}</p>
              </address>
            </li>
          </ol>

          <div id="insurance-claims-contact-link" class="mt-6">
            <button
              type="button"
              class="inline-flex items-center gap-1 text-ld-link font-medium hover:underline cursor-pointer bg-transparent border-none p-0"
              (click)="openSecureMessage()"
            >
              {{ 'insuranceClaimsContactSupport' | transloco }}
              <mat-icon class="size-5! text-xl!" aria-hidden="true">arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <aside id="insurance-claims-sidebar" class="flex flex-col gap-6">
        <ld-contact-card />
      </aside>
    </div>
  </div>
</section>
